module.exports = __webpack_public_path__ + "img/update-price.9c3d671c.png";